import type { GetStaticPaths, GetStaticProps } from "next"
import { PageMeta } from "@/components/resources/components/Seo/PageMeta"
import { AUTHORS, isAuthorSlug } from "@/components/resources/data/markdown/authors"
import { getAuthorTeasers } from "@/components/resources/data/markdown/posts"
import { SiteLayout } from "@/components/resources/layouts/site"
import { AuthorPage, type AuthorPageProps } from "@/components/resources/templates/AuthorPage"

const AuthorPosts = (props: AuthorPageProps) => {
  return (
    <>
      <PageMeta
        meta={{
          title: `Posts by ${props.author.nickname}`,
          description: `Posts by ${props.author.nickname}`,
          image: props.author.image,
        }}
      />
      <AuthorPage {...props} />
    </>
  )
}

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: Object.keys(AUTHORS).map((slug) => ({ params: { slug } })),
  fallback: false,
})

export const getStaticProps: GetStaticProps<AuthorPageProps, { slug: string }> = async ({
  params,
}) => {
  const slug = params?.slug
  if (!slug || !isAuthorSlug(slug)) {
    return { notFound: true }
  }

  return {
    props: {
      author: { id: slug, slug, ...AUTHORS[slug] },
      posts: await getAuthorTeasers(slug),
    },
    revalidate: 180,
  }
}

AuthorPosts.getLayout = SiteLayout

export default AuthorPosts
